import { useCallback } from 'react'
import BaseFilter from './BaseFilter'
import Companies from 'app/components/Icon/CompaniesIcon'
import { FilterObject } from 'app/filter.utils'
import { gqlFetchList } from 'app/lib/graphqlClient'

interface LocationFilterProps {
  customSearchParam: string
  preAppliedValues?: string | string[]
  defaultFilters?: FilterObject[]
}

export default function LocationFilter({ preAppliedValues, customSearchParam, defaultFilters }: LocationFilterProps) {
  const fetcher = useCallback(
    (params: { query: string }) => gqlFetchList('locations', { search: params.query || undefined }),
    [],
  )

  return (
    <BaseFilter
      attribute="locationId"
      displayName="Locations"
      shortName="Loc."
      icon={<Companies width={16} height={16} />}
      fetcher={fetcher}
      optionsMapper={(res) =>
        res?.hits?.map((location: any) => ({
          id: location.id,
          value: location.id,
          name: location.name,
        })) || []
      }
      preAppliedValues={preAppliedValues}
      customSearchParam={customSearchParam}
      defaultFilters={defaultFilters}
    />
  )
}
